var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-terms-page"},[_c('BackTitle',{class:['xs', 'sm'].includes(_vm.$mq) ? 'mb-40' : 'mb-64',attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create terms & conditions ")]),_c('TermsForm',{attrs:{"value":_vm.terms,"is-submitting":_vm.isSubmitting,"data-v-step":"4"},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }